(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendation"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            $('.product__recommendations__slider').slick({
              dots: false,
              arrows: true,
              infinite: false,
              centerMode: false,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              nextArrow: '.next',
              prevArrow: '.prev'
            });
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-recommendation"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            $('.product__recommendations__slider').slick({
              dots: false,
              arrows: true,
              infinite: false,
              centerMode: false,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              nextArrow: '.next',
              prevArrow: '.prev'
            });
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize-ring"]) return;
  try {
    

    /**
     * Ring Customizer v 0.1.3
     *
     * @author: ATF-Leysam
     *
     * Ring customizer script 
     * for Malka Diamond
     *
     */

    class CustomizeRing extends HTMLElement {


        constructor() {
            super();
        }

        connectedCallback() {

          // Global Object
          this.StepLists = $('.customize-ring__step');
          this.MainContent = $('#MainContent');
          this.RingBuidler = $('.customize-ring-builder');
          this.Selections = $('.customize-ring__step--selections');
          this.NotRingBuidler = this.MainContent.find('.shopify-section').not(this.RingBuidler);

          // Global Support Classes
          this.NavigationClass = '.customizer-navigation';
          this.Navigation_PrevClass = '.customizer-navigation__prev';
          this.Navigation_NextClass = '.customizer-navigation__next';
          this.Selection = '.customize-ring__step--selection';
          this.ActiveSelection = '.customize-ring__step--selection.active-selection';
          this.MessageClass = '.customizer-navigation-message';
          
          
          
          this.hashHandler = this.locationHashChanged.bind(this);
          window.onhashchange = this.hashHandler;

          this.constructRingSection();
          this.constructSelections();
          this.hashHandler();

            var eventMethod = window.addEventListener
                ? "addEventListener"
                : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod === "attachEvent"
                ? "onmessage"
                : "message";
            let that = this;

            $('a[href="#start"]').on('click', function(e){
                e.preventDefault();
                that.changeStep("start");
            });


            $('.letsgetStarted').on('click', function(e){
                var selectForm = $('.select__step1');
                e.preventDefault();
                
                var MessageElem = $('.letsget-started');
                if (selectForm.val() == 'Please Select') {
                    MessageElem.html('<span class="error--message">Please select an option to continue</span>');
                    MessageElem.addClass('show-message');
                } else {
                    MessageElem.removeClass('show-message');
                    that.changeStep("stone-type");
                }

            });

            
            eventer(messageEvent, function (e) {

                
                if (e.origin !== 'https://formbuilder.hulkapps.com') return;
                if (e.data === "myevent" || e.message === "myevent") 
                    alert('Message from iframe just came!');
                
                if (typeof e.data !== "object") {
                    let data = JSON.parse(e.data);

                    if (data.image) {
						console.log(data.image.url)
                        $('#customizer-attachment').val(data.image.url);
                        that.showSummary();
                    }
                }
            });
        }


        constructRingSection() { 

            let that = this;

            this.Selections.slick({
                infinite: false,
                fade: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
						dots: true,
                        centerMode: false, 
                        slidesToScroll: 3
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 1,
						dots: true,
                        centerMode: false, 
                        slidesToScroll: 1
                      }
                    }
				]
            });

            this.StepLists.each(function(){
                let CurrentStepList = $(this),
                    Navigation = CurrentStepList.find(that.NavigationClass),
                    StepCount = CurrentStepList.data('step'),
                    StepName = CurrentStepList.data('step-name'),
                    NavPrevious = Navigation.find(that.Navigation_PrevClass), 
                    NavNext = Navigation.find(that.Navigation_NextClass);

                
                NavPrevious.hide();

                if (StepCount > 1) {
                    NavPrevious.show();
                }

                let StepObject = $(this),
                    NextStepObject = $(StepObject.next()[0]),
                    PrevStepObject = $(StepObject.prev()[0]);

                NavNext.on('click', function(){

                    let Step = NextStepObject.data('step'),
                        Name = NextStepObject.data('step-name');


                    if (StepName == 'final') {
                        $('#CustomizeRingForm-success').submit();
                    } else {
                        if (that.validateSection(CurrentStepList)) {
                            that.changeStep(Name);
                        }
                    }
                    
                    that.showSummary()
                })


                NavPrevious.on('click', function(){

                    let Step = PrevStepObject.data('step'),
                        Name = PrevStepObject.data('step-name');

                    
                    that.changeStep(Name);

                })

            });
        }

        scrollBodyTop() {
            $("body, html").animate({
                scrollTop: '160px'
            }, 500);
        }

        constructSelections() {
            let that = this;
            this.Selections.find(this.Selection).each(function(){
                let Selection = $(this),
                    Multiple = Selection.parent().parent().parent().parent().parent().hasClass('multiple-selection');

                Selection.on('click', function(){
                    Selection.toggleClass('active-selection');
                    console.log(Multiple);
                    if ( !Multiple) {
                        Selection.parent().find(that.Selection).not(Selection).removeClass('active-selection');
                    }


                    let Parent = Selection.parent().parent().parent().parent().parent();
                    Parent.find('.step--field').val(Selection.data('title'));

                    if (Parent.find('.active-selection').length > 0) {
                        let MessageElem = Parent.find(that.MessageClass);
                        MessageElem.removeClass('show-message');
                    }
                });

            });
        }

        validateSection(Section) {

            if (Section.find('.active-selection').length > 0) {
                return true;
            }


            if (!Section.data('skip-validation')) {
                let SectionName = Section.find('.customize-ring__step--title').text(),
                MessageElem = Section.find(this.MessageClass);

                MessageElem.html('<span class="error--message">Please select a ' + SectionName + ' to continue</span>');
                MessageElem.addClass('show-message');
            } else {
                return true;
            }

            return false;
        }


        showSummary() {
            let Data = this.getSumaryData(), that = this;
            $('.customize-ring__step--summary').html("");


            Data.forEach( summary => {
                let Holder = $('<div />').addClass('summary-wrap'),
                    Category =  $('<div />').addClass('summary-category'),
                    Content =  $('<div />').addClass('summary-content'),
                    Action =  $('<div />').addClass('summary-action');

                    Holder.append(Category);
                    Holder.append(Content);
                    Holder.append(Action);

                    let $image = $('<img />').attr('src', summary.image);
                    Category.append('<div class="summary-heading">' + summary.StepName+ ':</div>');
                    Category.append($image);

                    let SkipSummary = false;

                    if (typeof summary.data == "object") {

                        if (summary.data.length > 0) {
                            summary.data.forEach( data => {
                                let $data = $('<div class="summary-info">' + 
                                    '<div class="summary-info--title">' + data.title + '</div>' + 
                                    '<div class="summary-info--description">' + data.description + '</div>' + 
                                '</div>');

                                if (data.title == 'Attachment') {
                                    $data.find('.summary-info--description').html('<a href="' + data.description + '" target="_blank">Attached File</a>');
                                }
                                Content.append($data);
                            });
                        } else {
                            SkipSummary = true;
                        }
                    } else {

                        let $data = $('<div class="summary-info">' + 
                            '<div class="summary-info--title">' + summary.title + '</div>' + 
                            '<div class="summary-info--description">' + summary.description + '</div>' + 
                        '</div>');
                        Content.append($data);
                    }

                    Action.on('click', function(){
                        that.changeStep(summary.name)
                    })
                    
                    
                    if ( SkipSummary == false ) $('.customize-ring__step--summary').append(Holder);

            });
        }

        getSumaryData() {
            let ActiveSelections = $(this.ActiveSelection);

            let ResultData = [];


            ActiveSelections.each(function(){
                let $self = $(this),
                    StepName = $self.data('step-title'),
                    name = $self.data('step-name'),
                    title = $self.data('title'),
                    description = $self.data('description'),
                    image = $self.data('image'),
                    label = $self.data('label');

                let compiledData = {StepName, title, description, image, label, name }


                ResultData.push(compiledData);
            }); 


            // additional information


            let AdditionalInfoData = [];

            $('.customize-ring__fields').each(function (){
                let $self = $(this),
                    title = $self.data('title'),
                    name = $self.data('step-name'),
                    description = $self.val();

                var is_radio_input = $self.is('input[type="radio"]');

                if (is_radio_input) {
                    if ($self.is(":checked")) {
                        AdditionalInfoData.push({title, name, description});
                    } 
                } else {
                    if (description != '') AdditionalInfoData.push({title, name, description});
                }
            });

            
            let $self = $(this),
                StepName = 'More info', image = 'https://cdn.shopify.com/s/files/1/0563/2727/4695/t/2/assets/moreinfo-img.png',
                name = 'additional-info',
                data = AdditionalInfoData;
            let compiledData = {StepName, image, data, name }
            
            ResultData.push(compiledData);
            return ResultData;
        }

        changeStep(Name) {
           window.location.hash = Name;
           this.scrollBodyTop();
        }

        showCustomizer() {
            this.NotRingBuidler.hide();
            this.RingBuidler.addClass('active');

            this.Selections.slick('setPosition'); // reset slick position
        }

        hideCustomizer() {
            this.NotRingBuidler.hide();
        }

        locationHashChanged() {
            let currentHash = location.hash.replace("#", ""),
                that = this;

            let NoPageFound = true;

            this.StepLists.each(function(){
                let $self = $(this),
                    step = $self.data('step'),
                    stepName = $self.data('step-name');


                if (currentHash == stepName || currentHash == step) {

                    if (currentHash == 'CustomizeRingForm-success') {
                        $("body").addClass('custom-ring__form-sucess');
                    }
                    that.StepLists.not($self).removeClass('active');
                    $self.addClass('active');

                    that.showCustomizer();
                    NoPageFound = false;

                    return false; // breaks
                }
                
            });

        }
          
        navigateStep(step) {

        }
    
    }

    customElements.define('customize-ring', CustomizeRing);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    

    $('#paginateBy3').on('change', function(){
      var val = $(this).val();
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[pagination]": val},
        success: function(d){
        window.location.reload();
        },
        dataType: 'json'
      });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

    $('#paginateBy').on('change', function(){
      var val = $(this).val();
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[pagination]": val},
        success: function(d){
        window.location.reload();
        },
        dataType: 'json'
      });
    });

    $('#paginateBy1').on('change', function(){
      var val = $(this).val();
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[pagination]": val},
        success: function(d){
        window.location.reload();
        },
        dataType: 'json'
      });
    });



    $(document).ready(function () {
      $body = $("body");
      $(document).pjax('#MainContent .lablel__checkbox a', '#MainContent', { fragment: '#MainContent', timeout: 10000, scrollTo: false, push: true });
      $(document).on('pjax:start', function(){
        $('.collection').addClass("loading");
        $('#MainContent').fadeTo('slow', 0.8);
      })
      var DontReplace = false;
      $(document).on('pjax:beforeReplace', function(options, contents){
         if ($(contents).find('.no-product-found').length > 0) {
          DontReplace = true;

         }
      });
      $(document).on('pjax:end', function(){
          $body.removeClass("pt-ajax-loading");
          $('#MainContent').fadeTo('fast', 1);
        $('.collection').removeClass("loading");


        $(".Collection__list__filter__head").click(function() {
          if ($(this).parent().hasClass('ActiveFilters')) {
            $(".Collection__list__filter__body").slideUp(300);
            $(".Collection__list__filter__head .icon").text('+');
          }
          if ($(this).next(".Collection__list__filter__body").is(':visible')) {
            $(this).next(".Collection__list__filter__body").slideUp(300);
            $(this).children(".Collection__list__filter__head .icon").text('+');
          } else {
            $(this).next(".Collection__list__filter__body").slideDown(300);
            $(this).children(".Collection__list__filter__head .icon").text('-');
          }
        });
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            $('.product__recommendations__slider').slick({
              dots: false,
              arrows: true,
              infinite: false,
              centerMode: false,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              nextArrow: '.next',
              prevArrow: '.prev'
            });
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  

  } catch(e) { console.error(e); }
})();
})();
